import React from 'react'
import TabsContent from '../../molecules/tabs-content/tabs-content'

import './participate-section.scss'
const ParticipateSection = ({ id, className }) => {
  return (
    <section id={id} className={'f-participate-section ' + className}>
      <div className="f-participate-section__wrapper">
        <h2 className="f-participate-section__titleSection">
          ¿Cómo participar?
        </h2>
      </div>
      <TabsContent classNameForHeader={'--maxwidth'} />
    </section>
  )
}

export default ParticipateSection
